<template>
  <WBDBlackListManager
    :organization="organization"
    show-add-btn
  />
</template>

<script>
import WBDBlackListManager from '@/views/blackList/view'

export default {
  name: 'OrganizationBlackListPage',
  components: { WBDBlackListManager },

  validations: {
    organization: {
    }
  },
  props: {
    organization: {
      type: Object
    }
  },
  data: () => ({


  }),
  computed: {

  },
  watch: {

  },

  created () {
  },
  methods: {
  }
}
</script>


